import React, { type ReactNode } from 'react';
import { AccordionItem } from './AccordionItem';
type AccordionLine = {
  bottomLeft?: ReactNode;
  bottomRight?: ReactNode;
  children?: ReactNode;
  component?: ReactNode;
  dataTestId?: string;
  iconName?: string;
  isFirstItem?: boolean;
  isLastItem?: boolean;
  isNull?: boolean;
  isOpenedByDefault?: boolean;
  topLeft?: ReactNode;
  topRight?: ReactNode;
  trackingData?: { event?: string; payload?: Record<string, unknown> };
};
type Props = {
  lines: Array<AccordionLine>;
  children?: ReactNode;
  trackingEventName: string;
};
export const AccordionBlock = ({ trackingEventName, lines, children }: Props) => {
  return (
    <div>
      {lines.map((props, index) => {
        return (
          <AccordionItem
            key={index}
            {...props}
            trackingData={{
              ...props.trackingData,
              event: trackingEventName || props.trackingData?.event,
            }}
          />
        );
      })}
      {children}
    </div>
  );
};
